// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_ESHOP_PRODUCT_SHORT = "ESHOP";
export const BZ2_OLD_PRODUCT_SHORT = "Pou\u017eit\u00fd";
